import { QueryClient } from "@tanstack/react-query";
export var queryClient = new QueryClient();
